module.exports = __webpack_public_path__ + "static/homepage-c35dfcb8b316e7be5b18a156393e560f.jpg";